/**
 * 存储localStorage
 */
export const setStore = (name, content) => {
  if (!name) return
  window.localStorage.removeItem(name)
  if (content === null || content === undefined) {
    content = ''
  }
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  window.localStorage.setItem(name, content)
}

/**
 * 获取localStorage
 */
export const getStore = name => {
  if (!name) return
  return window.localStorage.getItem(name)
}

/**
 * 删除localStorage
 */
export const removeStore = name => {
  if (!name) return
  window.localStorage.removeItem(name)
}



// WEBPACK FOOTER //
// ./src/utils/storage.js